<script>
    import { fade } from 'svelte/transition';
    import {link , push} from 'svelte-spa-router'
    import fetchData from '../api.js';
    import UserStore from '../stores/user.js';
    import { _ } from "svelte-i18n";
    import { onMount , onDestroy } from 'svelte';
    import Header from '../components/Header.svelte';
    import TopInfo from '../components/TopInfo.svelte';  
    import Orders from '../components/Orders.svelte'; 
    import Preloader from '../components/Preloader.svelte'; 
    import { DatePicker } from "@svelte-plugins/datepicker";
    import Pagination from '../components/Pagination.svelte'; 
    import { updateUrlParam } from '../base/url.js';
    import { format } from 'date-fns';
    import Chart from "../components/Chart.svelte";


    export let params;

    let isLoading = false;

    let customers_count = 0;
    
    let customers = {
        data : [],
        list : []
    };

    const today = new Date();

    const MILLISECONDS_IN_DAY = 24 * 60 * 60 * 1000;

    const getDateFromToday = (days) => {
        return Date.now() - days * MILLISECONDS_IN_DAY;
    };

    let startDate = getDateFromToday(29);
    let endDate = today;
    let keys = []; // Keys for dropdown options
    let filterKey = ""; // Default filter key
    let filterValue = "";


    // Sorting State
    let sortKey = "creation_date";
    let sortDirection = "asc"; // 'asc' or 'desc'


    let isDateFilter = false;
    $: isDateFilter = filterKey.toLowerCase().includes("date");


    let barChartData  = {}
    let lineChartData = {}    
    let totalDoorShipments = {}
    let totalPickupShipments= {}
    let doughnutChartData = {}
    let pieChartData  = {}
  

    
    onMount(async() => {

        //console.log('UserStore',$UserStore)

        if (!$UserStore || !$UserStore.data){
            push('/login');
            return;
        }
        
        isLoading = true;

        let postData = {};

        postData.action = 'crm_get_customers_manager';
        if (typeof params !=="undefined" && typeof params.user_id !=="undefined") {
            postData.user_id = $UserStore.id
        }
        postData.token = $UserStore.data
        let customers_response = await fetchData(postData);

        isLoading = false;        

        if (customers_response.data) {

            customers.data = customers_response.data.filter((data)=> {

                if (data.url!=null && !data.url.includes('localhost') && !data.url.includes('taltal') && !data.url.includes('dreamax')) {
                    
                    customers_count++;

                    // door_count = door_count + parseInt(data.door_shipments_count);
                    // pickup_count = pickup_count + parseInt(data.pickup_shipments_count);
                    return true;

                }  else {

                    return false;

                }
                
            })

            keys = Object.keys(customers.data[0] || {}); // Extract keys from the first item
            filterKey = keys[0] || ""; // Default filter key to the first key

            customers.list = [...customers.data ];

        } 

      
    })    


    // Sorting Function
    const sortData = (key) => {
        sortKey = key;
        sortDirection = sortDirection === "asc" ? "desc" : "asc";

        const sortedData = [...customers.data].sort((a, b) => {
            let valA = a[key];
            let valB = b[key];

            // Numeric sorting if applicable
            if (!isNaN(valA) && !isNaN(valB)) {
                valA = parseFloat(valA);
                valB = parseFloat(valB);
            }

            // Compare values
            if (valA < valB) return sortDirection === "asc" ? -1 : 1;
            if (valA > valB) return sortDirection === "asc" ? 1 : -1;
            return 0;
        });

        customers.list = sortedData;
        updateChart();
    
    };


    const filterData = () => {
        const filteredData = customers.data.filter((item) => {
            const value = item[filterKey];
            if (startDate && value < startDate) 
                return false;
            if (endDate && value > endDate) 
                return false;
            return true;
        });

        // Apply filtered data
        customers.list = filteredData;
        updateChart();
    };


    function updateChart() {

        // Chart 1: Total shipments by company (Bar Chart)
        barChartData = {
            labels: customers.list.slice(0, 10).map((item) => item.company),
            datasets: [
                {
                    label: "Total Shipments",
                    data: customers.list.map(
                        (item) =>
                            parseInt(item.door_shipments_count) +
                            parseInt(item.pickup_shipments_count)
                    ),
                    backgroundColor: ["#FF6384", "#36A2EB", "#FFCE56"],
                },
            ],
        };

        // Chart 3: Door vs Pickup shipments (Pie Chart)
        totalDoorShipments = customers.list.reduce(
            (sum, item) => sum + parseInt(item.door_shipments_count),
            0
        );
        totalPickupShipments = customers.list.reduce(
            (sum, item) => sum + parseInt(item.pickup_shipments_count),
            0
        );
        pieChartData = {
            labels: ["Door Shipments", "Pickup Shipments"],
            datasets: [
                {
                    data: [totalDoorShipments, totalPickupShipments],
                    backgroundColor: ["#FF6384", "#36A2EB"],
                },
            ],
        };

 

    }

    
</script>

<style>
    .dash-list h1 {
        margin-bottom: 0;
    }
</style>


<div class="page-container" transition:fade={{ delay: 250, duration: 300 }}>
    <Preloader {isLoading}/>
    <Header />
    <div class="page">

        <!-- <TopInfo />   
         -->
        <div class="dash-list">

            <!-- <div class="charts grid grid-cols-4 gap-4">
                <div>
                    <h2>Total Shipments by Company</h2>
                    <Chart type="bar" data={barChartData} />
                </div>
                <div>
                    <h2>Door vs Pickup Shipments</h2>
                    <Chart type="bar" data={pieChartData} />
                </div>
       
            </div> -->
              

            <div class="flex col-reverse w-full items-end justify-between mb-[30px]">
                <h1>{$_('partners.customers')} ({customers.data.length})</h1>
                
                <div>
                    <div class="filter-controls flex gap-2">
                        {#if isDateFilter}
                            <!-- Date Inputs -->
                            <div>
                                <label for="startDate">{$_('partners.start')}:</label>
                                <input type="date" id="startDate" bind:value={startDate} />
                            </div>
                            <div>
                                <label for="endDate">{$_('partners.end')}:</label>
                                <input type="date" id="endDate" bind:value={endDate} />
                            </div>
                        {:else}
                            <!-- General Input -->
                            <div>
                                <label for="startDate">{$_('partners.start')}:</label>
                                <input type="text" bind:value={startDate} />
                            </div>
                            <div>
                                <label for="endDate">{$_('partners.end')}:</label>
                                <input type="text" bind:value={endDate} />
                            </div>
                        {/if}
                        <div>
                          <label for="filterKey">{$_('partners.filter_by')}:</label>
                          <select id="filterKey" bind:value={filterKey} disabled={!keys.length}>
                            {#if keys.length}
                              {#each keys as key}
                                <option value={key}>{key}</option>
                              {/each}
                            {:else}
                              <option>Loading...</option>
                            {/if}
                          </select>
                        </div>
                        <div>
                            <div class="p-3"></div>
                            <button on:click={filterData} class="bg-black text-white py-2 px-3 rounded">{$_('partners.filter')}</button>
                        </div>
                    </div>
                </div>
                
                <span on:click={()=> push('/create_customer/' )} class="create_button m-0"><span>{$_('partners.create_customer')}</span></span>
            </div>

            

            <div class="table">
                <div class="head">
                    <div class="cursor-pointer" on:click={() => sortData("creation_date")}>{$_("partners.join_date")}</div>
                    <div class="cursor-pointer" on:click={() => sortData("company")}>{$_("partners.company")}</div>
                    <div class="cursor-pointer" on:click={() => sortData("contract")}>{$_("partners.contract")}</div>
                    <div class="cursor-pointer" on:click={() => sortData("phone")}>{$_("partners.phone")}</div>
                    <div class="cursor-pointer" on:click={() => sortData("door_shipments_count")}>{$_("partners.door")}</div>
                    <div class="cursor-pointer" on:click={() => sortData("pickup_shipments_count")}>{$_("partners.pickup")}</div>
                    <div class="cursor-pointer" on:click={() => sortData("total_shipments")}>{$_("partners.shipments")}</div>
                    <div class="cursor-pointer" on:click={() => sortData("url")}>{$_("partners.url")}</div>
                    <div class="cursor-pointer" on:click={() => sortData("date")}>{$_("partners.last_shipment_date")}</div>
                  </div>
                {#each customers.list as item,index}
                    <div>
                        <div>{item.creation_date}</div>
                        <div>{item.company}</div>
                        <div>{item.contract}</div>
                        <div>{item.phone}</div>
                        <div>{item.door_shipments_count}</div>
                        <div>{item.pickup_shipments_count}</div>
                        <div>{parseInt(item.door_shipments_count) + parseInt(item.pickup_shipments_count)}</div>
                        <div>{item.url}</div>
                        <div>{item.date}</div>
                    </div>
                {/each}
            </div>
        </div>
    </div>
</div>